import script from "./ExpirationAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpirationAlerts.vue?vue&type=script&setup=true&lang=js"

import "./ExpirationAlerts.vue?vue&type=style&index=0&id=aae58ef6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aae58ef6"]])

export default __exports__